export abstract class Mapper<I, O> {
    abstract mapperFrom(payload: I): O;
    abstract mapperTo(payload: O): I;
}
